import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const isEmailValidated = createSelector(membersState, (members) => (members.data ? members.data.IsEmailValidated : false));
